import React, { useState } from 'react'
import { Typography, Input, Textarea, Button, Alert, Select, Option } from '../../lib/mt-native'
import map1 from '../../../images/map1.png';
import map2 from '../../../images/map2.png';
import map3 from '../../../images/map3.png';
import Image from 'next/image';

const ContactForm = ({ title }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    email: '',
    phone: '',
    region: '',
    subject: '',
    message: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.firstName.trim()) {
      newErrors.firstName = 'First name is required';
    } else if (formData.firstName.trim().length < 2) {
      newErrors.firstName = 'First name must be at least 2 characters';
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Last name is required';
    } else if (formData.lastName.trim().length < 2) {
      newErrors.lastName = 'Last name must be at least 2 characters';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    const phoneRegex = /^(?:\+\d{1,4}|0)[2-9]\d{7,9}$/;
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!phoneRegex.test(formData.phone)) {
      newErrors.phone = 'Please enter a valid phone number';
    }

    if (!formData.region) {
      newErrors.region = 'Region is required';
    }

    if (!formData.subject.trim()) {
      newErrors.subject = 'Subject is required';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Failed to send message');
      }

      setIsSubmitted(true);
      setFormData({
        firstName: '',
        lastName: '',
        companyName: '',
        email: '',
        phone: '',
        region: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      setErrors({
        submit: 'There was a problem sending your message. Please try again.'
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="min-h-[500px] flex items-center justify-center">
        <div className="text-center space-y-4 max-w-md">
          <Typography variant="h4" className="mb-2 text-primary font-heading">
            Thank You!
          </Typography>
          <Typography variant="paragraph" color="blue-gray" className="mb-4">
            Your message has been received. We will get back to you as soon as possible.
          </Typography>
          <Button
            onClick={() => {
              setIsSubmitted(false);
              setErrors({});
            }}
            className="mt-4 rounded-none bg-transparent text-black border border-black hover:bg-black hover:text-white transition-all"
          >
            Send Another Message
          </Button>
        </div>
      </div>
    );
  }

  const ContactInfo = () => (
    <div className="space-y-8">
      <div>
        <Typography variant="h3" className="mb-6 text-primary font-heading">
          Contact RK Timbers
          </Typography>
          <Typography variant="h6" className="mb-6 text-primary font-heading">
          Specialist timber merchant and importers
          </Typography>
        <Typography variant="paragraph" className="text-blue-gray-700 mb-6">
          Our expert team are ready to assist with your timber requirements, and are happy to help with questions about timber species, timber certification and timber specifications.
          You can contact us directly, or submit your enquiry using the form below. We&apos;ll respond to your email within one working day.
        </Typography>
      </div>

      <div className="space-y-4">
        <div>
          <Typography variant="h5" className="text-primary font-heading">
            Auckland Head Office
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700 mb-2">For all Head Office enquiries</Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
            Telephone: 0800 484 695<br/>
            Fax: (09) 620 0261
          </Typography>
        </div>

        <div>
          <Typography variant="h6" className="mb-2 text-primary font-heading">
          Address
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
            26 Keeling Road<br/>
            Henderson<br/>
            Auckland 0612
          </Typography>
        </div>
        <div>
        <a target='_blank' href='https://maps.app.goo.gl/GM5Tm7zpQzpJLLvb7' className="mb-2 text-primary">
          <Image src={map1} className="me-3" alt="RK Timber" />        
        </a>        
        </div>
        <div>
          <Typography variant="h6" className="mb-2 text-primary font-heading">
          Hours
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
          Monday to Friday: 7:30am to 5:00pm<br/>
          Saturday to Sunday: Closed
          </Typography>
        </div>
        <div>
          <Typography variant="h6" className="mb-2 text-primary font-heading">
          Email
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
          sales@iti.net.nz
          </Typography>
        </div>
        
      </div>
      <div className="space-y-4">
        <div>
          <Typography variant="h5" className="text-primary font-heading">
          Carterton
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700 mb-2">For all lower North Island enquiries</Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
            Telephone: 0800 484 695<br/>
            Fax: (06) 379 9382
          </Typography>
        </div>

        <div>
          <Typography variant="h6" className="mb-2 text-primary font-heading">
          Address
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
          30 Kent Street<br/>
          Carterton 5713<br/>
          PO Box 139 Carterton New Zealand 5473
          </Typography>
        </div>
        <div>
        <a target='_blank' href='https://maps.app.goo.gl/efZJmy6CHeQPhDuW7' className="mb-2 text-primary">
          <Image src={map2} className="me-3" alt="RK Timber" />        
        </a>        
        </div>
        <div>
          <Typography variant="h6" className="mb-2 text-primary font-heading">
          Hours
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
          Monday to Friday: 7:00am to 4:00pm<br/>
          Saturday to Sunday: Closed
          </Typography>
        </div>
        <div>
          <Typography variant="h6" className="mb-2 text-primary font-heading">
          Email
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
          sales@iti.net.nz
          </Typography>
        </div>
        
      </div>
      <div className="space-y-4">
        <div>
          <Typography variant="h5" className="text-primary font-heading">
          Christchurch
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700 mb-2">For all South Island related enquiries</Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
            Telephone: 0800 484 695<br/>
            Fax: (03) 384 5289
          </Typography>
        </div>

        <div>
          <Typography variant="h6" className="mb-2 text-primary font-heading">
          Address
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
          14 Braeburn Drive<br/>
          Hornby<br/>
          Christchurch 8042<br/>
          PO Box 6387 Upper Riccarton Christchurch 8442
          </Typography>
        </div>
        <div>
        <a target='_blank' href='https://maps.app.goo.gl/2vRzmpbDzu7cTZXf7' className="mb-2 text-primary">
          <Image src={map3} className="me-3" alt="RK Timber" />        
        </a>        
        </div>
        <div>
          <Typography variant="h6" className="mb-2 text-primary font-heading">
          Hours
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
          Monday to Friday: 7:30am to 5:00pm<br/>
          Saturday to Sunday: Closed
          </Typography>
        </div>
        <div>
          <Typography variant="h6" className="mb-2 text-primary font-heading">
          Email
          </Typography>
          <Typography variant="paragraph" className="text-blue-gray-700">
          sales@iti.net.nz
          </Typography>
        </div>
        
      </div>
    </div>
  );


  return (
    <div className="container">
      <div className="grid md:grid-cols-2 gap-12 items-start">
        {/* Form Column */}
        <div className="space-y-6">
          <Typography variant="h3" className="mb-6 text-primary font-heading">
          Enquire now
          </Typography>
          
          {errors.submit && (
            <Alert color="red" variant="gradient" className="rounded-none">
              {errors.submit}
            </Alert>
          )}

<form 
          onSubmit={handleSubmit} 
          className="space-y-6"
          data-netlify="true"
          name="contact"
          method="POST"
          netlify-honeypot="bot-field"
        >
          <input type="hidden" name="form-name" value="contact" />
          <div className="hidden">
            <label>
              Do not fill this out if you are human: <input name="bot-field" />
            </label>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <Input
                variant="outlined"
                label="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                error={!!errors.firstName}
                className="rounded-none !bg-[#E2DDDB] !text-black"
                labelProps={{
                  className: "!text-black"
                }}
              />
              {errors.firstName && (
                <Typography
                  variant="small"
                  color="red"
                  className="mt-1"
                >
                  {errors.firstName}
                </Typography>
              )}
            </div>

            <div>
              <Input
                variant="outlined"
                label="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                error={!!errors.lastName}
                className="rounded-none !bg-[#E2DDDB] !text-black"
                labelProps={{
                  className: "!text-black"
                }}
              />
              {errors.lastName && (
                <Typography
                  variant="small"
                  color="red"
                  className="mt-1"
                >
                  {errors.lastName}
                </Typography>
              )}
            </div>
          </div>

          <div>
            <Input
              variant="outlined"
              label="Company Name"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              className="rounded-none !bg-[#E2DDDB] !text-black"
              labelProps={{
                className: "!text-black"
              }}
            />
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <Input
                type="email"
                variant="outlined"
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                className="rounded-none !bg-[#E2DDDB] !text-black"
                labelProps={{
                  className: "!text-black"
                }}
              />
              {errors.email && (
                <Typography
                  variant="small"
                  color="red"
                  className="mt-1"
                >
                  {errors.email}
                </Typography>
              )}
            </div>

            <div>
              <Input
                type="tel"
                variant="outlined"
                label="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                error={!!errors.phone}
                className="rounded-none !bg-[#E2DDDB] !text-black"
                labelProps={{
                  className: "!text-black"
                }}
              />
              {errors.phone && (
                <Typography
                  variant="small"
                  color="red"
                  className="mt-1"
                >
                  {errors.phone}
                </Typography>
              )}
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <Select
                variant="outlined"
                label="Region"
                name="region"
                value={formData.region}
                onChange={(val) => handleChange({ target: { name: 'region', value: val } })}
                error={!!errors.region}
                className="rounded-none !bg-[#E2DDDB] !text-black"
                labelProps={{
                  className: "!text-black"
                }}
              >
                <Option value="Northland">Northland</Option>
                <Option value="Auckland">Auckland</Option>
                <Option value="Bay of Plenty">Bay of Plenty</Option>
                <Option value="Gisborne">Gisborne</Option>
                <Option value="Hawke&apos;s Bay">Hawke&apos;s Bay</Option>
                <Option value="Taranaki">Taranaki</Option>
                <Option value="Manawatu-Wanganui">Manawatu-Wanganui</Option>                
                <Option value="Wellington">Wellington</Option>
                <Option value="Waikato">Waikato</Option>
                <Option value="Nelson">Nelson</Option>
                <Option value="Marlborough">Marlborough</Option>
                <Option value="West Coast">West Coast</Option>
                <Option value="Tasman">Tasman</Option>
                <Option value="Canterbury">Canterbury</Option>
                <Option value="Otago">Otago</Option>
                <Option value="Southland">Southland</Option>
              </Select>
              {errors.region && (
                <Typography
                  variant="small"
                  color="red"
                  className="mt-1"
                >
                  {errors.region}
                </Typography>
              )}
            </div>

            <div>
              <Input
                variant="outlined"
                label="Subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                error={!!errors.subject}
                className="rounded-none !bg-[#E2DDDB] !text-black"
                labelProps={{
                  className: "!text-black"
                }}
              />
              {errors.subject && (
                <Typography
                  variant="small"
                  color="red"
                  className="mt-1"
                >
                  {errors.subject}
                </Typography>
              )}
            </div>
          </div>

          <div>
            <Textarea
              variant="outlined"
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              error={!!errors.message}
              className="min-h-[150px] rounded-none !bg-[#E2DDDB] !text-black"
              labelProps={{
                className: "!text-black"
              }}
            />
            {errors.message && (
              <Typography
                variant="small"
                color="red"
                className="mt-1"
              >
                {errors.message}
              </Typography>
            )}
          </div>

          <Button
            type="submit"
            variant="text"
            fullWidth
            disabled={isLoading}
            className="mt-6 rounded-none bg-transparent text-black border border-black hover:bg-black hover:text-white transition-all normal-case"
          >
            {isLoading ? 'Sending...' : 'Send Message'}
          </Button>
        </form>
        </div>

        {/* Contact Info Column */}
        <div className="md:pl-12 md:border-l border-blue-gray-100">
          <ContactInfo />
        </div>
      </div>
    </div>
  );
};

export default ContactForm;